import {
  CssBaseline,
  ThemeProvider as MaterialThemeProvider,
} from "@mui/material";
import { PropsWithChildren, useEffect, useState } from "react";
import { useTheme } from "../hooks";
import { TRemoteThemeResponse, TThemeProvider } from "../types";

export const ThemeProvider = ({
  children,
  theme,
  remoteConfig,
}: PropsWithChildren<TThemeProvider>) => {
  const startLoading = import.meta.env.isTest === "true" ? false : true;
  const [isLoading, setIsLoading] = useState(startLoading);
  const [error, setError] = useState(false);
  const [remoteTheme, setRemoteTheme] = useState<
    TRemoteThemeResponse | undefined
  >(undefined);
  const { url, headers, method = "GET" } = remoteConfig || {};
  const muiTheme = useTheme(theme, remoteTheme);
  useEffect(() => {
    const fetchTheme = async () => {
      setError(false);
      if (url) {
        setIsLoading(true);
        await fetch(url, { method, headers, signal: AbortSignal.timeout(4000) })
          .then(res => {
            return res.json();
          })
          .then((json: TRemoteThemeResponse) => {
            setRemoteTheme(json);
          })
          .catch(() => {
            setError(true);
            setRemoteTheme(undefined);
          })
          .finally(() => {
            setIsLoading(false);
          });
      }
    };
    if (!error && !remoteTheme && remoteTheme !== null) {
      fetchTheme().catch(console.log);
    }
  }, [error, headers, isLoading, method, remoteTheme, url]);
  if (isLoading) return null;
  return (
    <MaterialThemeProvider theme={muiTheme}>
      <CssBaseline />
      {children}
    </MaterialThemeProvider>
  );
};
